module.exports = __webpack_public_path__ + "img/load.567e6144.gif";